export default __webpack_public_path__ + "media/images/react_icons/crockery-58943d7ae00ce6bb8514fea8cf754d93.svg";